import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../context/DarkModeContext';
import { CheckCircleIcon, CreditCardIcon, TruckIcon, ShieldCheckIcon } from 'lucide-react';
import { useDarkClasses } from '../hooks/useDarkClasses';
import { useRoleTheme } from '../hooks/useRoleTheme';
const Checkout = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    cardName: '',
    cardNumber: '',
    expDate: '',
    cvc: ''
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      // Process payment logic here
      alert('Order placed successfully!');
    }
  };
  return <div className={`min-h-screen py-12 px-4 sm:px-6 lg:px-8 ${dk.page}`} data-id="element-8915" data-mp="85eyx1zdg9zy">
      <div className="max-w-3xl mx-auto" data-id="element-8916" data-mp="cx6gin0jv5dy">
        {/* Progress Steps */}
        <nav aria-label="Progress" className="mb-12" data-id="element-8917" data-mp="hwjcpydb9ot7">
          <ol role="list" className="flex items-center" data-id="element-8918" data-mp="hvzwqn781aht">
            <li className={`relative pr-8 sm:pr-20 ${step > 1 ? rt.textPrimary : dk.textMuted}`} data-id="element-8919" data-mp="3geoocugboced">
              <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-8920" data-mp="3leb4bbnjc6qv">
                <div className={`h-0.5 w-full ${step > 1 ? rt.bgDark : dk.isDark ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-8921" data-mp="3qefj8x8sotez"></div>
              </div>
              <a href="#" className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step >= 1 ? `${rt.bgDark} text-white` : dk.badgeNeutral}`} data-id="element-8922" data-mp="15lkg377ae9rm">
                <CheckCircleIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-8923" data-mp="36mibrac539za" />
                <span className="sr-only" data-id="element-8924" data-mp="3forkpvrrevak">Step 1</span>
              </a>
              <span className={`absolute top-10 left-1/2 -translate-x-1/2 text-sm font-medium ${step >= 1 ? rt.textPrimary : dk.textMuted}`} data-id="element-8925" data-mp="3fmx9j96aihjo">
                Shipping
              </span>
            </li>
            <li className={`relative px-8 sm:px-20 ${step > 2 ? rt.textPrimary : dk.textMuted}`} data-id="element-8926" data-mp="2iz0nhos32u12">
              <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-8927" data-mp="2wr74te6z3723">
                <div className={`h-0.5 w-full ${step > 2 ? rt.bgDark : dk.isDark ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-8928" data-mp="2rxcehrwv3tu1"></div>
              </div>
              <a href="#" className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step >= 2 ? `${rt.bgDark} text-white` : dk.badgeNeutral}`} data-id="element-8929" data-mp="1za00450uusbt">
                <CreditCardIcon className={`h-5 w-5 ${step >= 2 ? 'text-white' : dk.textMuted}`} aria-hidden="true" data-id="element-8930" data-mp="jkqqs60pmbmu" />
                <span className="sr-only" data-id="element-8931" data-mp="as6zxrqntbck">Step 2</span>
              </a>
              <span className={`absolute top-10 left-1/2 -translate-x-1/2 text-sm font-medium ${step >= 2 ? rt.textPrimary : dk.textMuted}`} data-id="element-8932" data-mp="ygzp95cs0ky7">
                Payment
              </span>
            </li>
            <li className={`relative pl-8 sm:pl-20 ${step > 3 ? rt.textPrimary : dk.textMuted}`} data-id="element-8933" data-mp="ohh96zzzljbf">
              <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-8934" data-mp="tfshv7ejpns2">
                <div className={`h-0.5 w-full ${step > 3 ? rt.bgDark : dk.isDark ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-8935" data-mp="3e7ktqoetk2yz"></div>
              </div>
              <a href="#" className={`relative flex h-8 w-8 items-center justify-center rounded-full ${step >= 3 ? `${rt.bgDark} text-white` : dk.badgeNeutral}`} data-id="element-8936" data-mp="3tjls33xy2y21">
                <ShieldCheckIcon className={`h-5 w-5 ${step >= 3 ? 'text-white' : dk.textMuted}`} aria-hidden="true" data-id="element-8937" data-mp="3fq2xru3t6vko" />
                <span className="sr-only" data-id="element-8938" data-mp="ga6alu6tb750">Step 3</span>
              </a>
              <span className={`absolute top-10 left-1/2 -translate-x-1/2 text-sm font-medium ${step >= 3 ? rt.textPrimary : dk.textMuted}`} data-id="element-8939" data-mp="caff5d6cc2u5">
                Review
              </span>
            </li>
          </ol>
        </nav>

        <div className={`shadow overflow-hidden sm:rounded-lg ${dk.card}`} data-id="element-8940" data-mp="2s0ie18ztzuac">
          <div className="px-4 py-5 sm:px-6" data-id="element-8941" data-mp="2ryfenycsgosy">
            <h3 className={`text-lg leading-6 font-medium ${dk.textHeading}`} data-id="element-8942" data-mp="2n15qsn51sl78">
              {step === 1 ? 'Shipping Information' : step === 2 ? 'Payment Details' : 'Review Order'}
            </h3>
            <p className={`mt-1 max-w-2xl text-sm ${dk.textMuted}`} data-id="element-8943" data-mp="2mvoc6ra07xge">
              {step === 1 ? 'Please enter your shipping details.' : step === 2 ? 'Enter your payment information securely.' : 'Review your order before placing it.'}
            </p>
          </div>
          <div className={`border-t ${dk.border}`} data-id="element-8944" data-mp="30m9w8jb72dfv">
            <form onSubmit={handleSubmit} className="px-4 py-5 sm:p-6" data-id="element-8945" data-mp="30p5s823hes1o">
              {step === 1 && <div className="grid grid-cols-6 gap-6" data-id="element-8946" data-mp="35kbi1c008qv1">
                  <div className="col-span-6 sm:col-span-3" data-id="element-8947" data-mp="3ajxuvkbx853b">
                    <label htmlFor="first-name" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8948" data-mp="1b8emp7yfz0up">
                      First name
                    </label>
                    <input type="text" name="firstName" id="first-name" autoComplete="given-name" value={formData.firstName} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8949" data-mp="187bfr7tybp7m" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8950" data-mp="1m59o9wllcrf7">
                    <label htmlFor="last-name" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8951" data-mp="20uxtva0t2c8q">
                      Last name
                    </label>
                    <input type="text" name="lastName" id="last-name" autoComplete="family-name" value={formData.lastName} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8952" data-mp="29wxai17wreb5" />
                  </div>

                  <div className="col-span-6 sm:col-span-4" data-id="element-8953" data-mp="2kg7paz3a0mxr">
                    <label htmlFor="email-address" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8954" data-mp="25s367u0ba9eg">
                      Email address
                    </label>
                    <input type="text" name="email" id="email-address" autoComplete="email" value={formData.email} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8955" data-mp="1wsg2h1k40ri8" />
                  </div>

                  <div className="col-span-6" data-id="element-8956" data-mp="22aqhsrpvo4cz">
                    <label htmlFor="street-address" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8957" data-mp="22c1r1723e4bh">
                      Street address
                    </label>
                    <input type="text" name="address" id="street-address" autoComplete="street-address" value={formData.address} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8958" data-mp="1oc0o7m29omtd" />
                  </div>

                  <div className="col-span-6 sm:col-span-6 lg:col-span-2" data-id="element-8959" data-mp="10ld1hunozsmr">
                    <label htmlFor="city" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8960" data-mp="10o92jruu6xff">
                      City
                    </label>
                    <input type="text" name="city" id="city" autoComplete="address-level2" value={formData.city} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8961" data-mp="3m6wctduty4q6" />
                  </div>

                  <div className="col-span-6 sm:col-span-3 lg:col-span-2" data-id="element-8962" data-mp="37a5b2xxoogxe">
                    <label htmlFor="region" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8963" data-mp="37c9n635qkm8r">
                      State / Province
                    </label>
                    <input type="text" name="state" id="region" autoComplete="address-level1" value={formData.state} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8964" data-mp="2686n9n2a203q" />
                  </div>

                  <div className="col-span-6 sm:col-span-3 lg:col-span-2" data-id="element-8965" data-mp="1rir0sj9s4gtu">
                    <label htmlFor="postal-code" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8966" data-mp="1rgocq4s6sxrr">
                      ZIP / Postal code
                    </label>
                    <input type="text" name="zip" id="postal-code" autoComplete="postal-code" value={formData.zip} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8967" data-mp="13tpup2of5hrq" />
                  </div>
                </div>}

              {step === 2 && <div className="grid grid-cols-6 gap-6" data-id="element-8968" data-mp="nb1zinaoxwoi">
                  <div className="col-span-6 sm:col-span-3" data-id="element-8969" data-mp="iaxsdnvoaeay">
                    <label htmlFor="card-name" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8970" data-mp="dj61fc8lu6ka">
                      Name on card
                    </label>
                    <input type="text" name="cardName" id="card-name" autoComplete="cc-name" value={formData.cardName} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8971" data-mp="3m1bd1bn1qy7" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8972" data-mp="374pdyrqtex7f">
                    <label htmlFor="card-number" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8973" data-mp="3768tuh8k768o">
                      Card number
                    </label>
                    <input type="text" name="cardNumber" id="card-number" autoComplete="cc-number" value={formData.cardNumber} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8974" data-mp="8mjsz51wyx9l" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8975" data-mp="2c2nhs7pf3bcd">
                    <label htmlFor="expiration-date" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8976" data-mp="2c0u6gf3v02y1">
                      Expiration date (MM/YY)
                    </label>
                    <input type="text" name="expDate" id="expiration-date" autoComplete="cc-exp" value={formData.expDate} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8977" data-mp="2guyg564iep2t" />
                  </div>

                  <div className="col-span-6 sm:col-span-3" data-id="element-8978" data-mp="3djd2pzcevcz5">
                    <label htmlFor="cvc" className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-8979" data-mp="38l375nmryad0">
                      CVC
                    </label>
                    <input type="text" name="cvc" id="cvc" autoComplete="cc-csc" value={formData.cvc} onChange={handleInputChange} className={`mt-1 block w-full shadow-sm sm:text-sm rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 ${dk.input}`} data-id="element-8980" data-mp="cof181ez7r37" />
                  </div>
                </div>}

              {step === 3 && <div className="space-y-6" data-id="element-8981" data-mp="10f1blzcgdngd">
                  <div className={`p-4 rounded-md ${dk.surfaceMuted}`} data-id="element-8982" data-mp="15dm8boshxp02">
                    <h4 className={`text-sm font-medium ${dk.textPrimary}`} data-id="element-8983" data-mp="15foyc8tnfi4s">
                      Shipping Address
                    </h4>
                    <p className={`mt-2 text-sm ${dk.textSecondary}`} data-id="element-8984" data-mp="1edsmlcw0qt0a">
                      {formData.firstName} {formData.lastName}
                      <br data-id="element-8985" data-mp="2yxwc0jo7t19g" />
                      {formData.address}
                      <br data-id="element-8986" data-mp="2uuhv7qsgcguy" />
                      {formData.city}, {formData.state} {formData.zip}
                    </p>
                  </div>
                  <div className={`p-4 rounded-md ${dk.surfaceMuted}`} data-id="element-8987" data-mp="2pvwtto1grr4x">
                    <h4 className={`text-sm font-medium ${dk.textPrimary}`} data-id="element-8988" data-mp="2kxvbj5bv3vui">
                      Payment Method
                    </h4>
                    <p className={`mt-2 text-sm ${dk.textSecondary}`} data-id="element-8989" data-mp="3im53ssluj58f">
                      Card ending in {formData.cardNumber.slice(-4)}
                    </p>
                  </div>
                  {/* Order summary would go here */}
                </div>}

              <div className="mt-6 flex justify-end" data-id="element-8990" data-mp="33v5xxpceausj">
                {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className={`mr-3 px-4 py-2 rounded-md text-sm font-medium ${rt.outlineButton}`} data-id="element-8991" data-mp="567dt7p0xzan">
                    Back
                  </button>}
                <button type="submit" className={`px-4 py-2 rounded-md text-sm font-medium ${rt.primaryButton}`} data-id="element-8992" data-mp="1ynmx2b1qbqqm">
                  {step === 3 ? 'Place Order' : 'Next'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default Checkout;